import React, { memo } from 'react';
import { defineMessages, FormattedMessage, type MessageValue } from 'react-intl';
import { StyleSheet } from 'react-native';

import { BodyText, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationActiveIngredientAddMoreTitle = memo((props: Props) => {
  const { groupDisplayName } = props;

  return (
    <BodyText sizeMatch={['20']} style={styles.title}>
      <FormattedMessage
        {...messages.addMoreTitle}
        values={{ name: groupDisplayName.toLowerCase() }}
      />
    </BodyText>
  );
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages<{ readonly addMoreTitle: { readonly name: MessageValue } }>({
  addMoreTitle: {
    defaultMessage: 'Add {name}',
    description:
      'Customization | Active ingredient | Add title | The name of the group to add more ingredients',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  title: {
    color: theme.colors.KALE,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  groupDisplayName: string;
};
